import {CountryBrand, LegalEntity} from '../../domain/core/legal-entity.model';

export class AppState {
  static shared = new AppState();
  readonly userNameKey = 'userName';
  readonly legalEntityKey = 'legalEntity';
  readonly consentVersionKey = 'consentVersion';

  reset() {
    localStorage.setItem(this.userNameKey, '');
  }

  get userName(): string {
    return localStorage.getItem(this.userNameKey);
  }

  setUserName(userName: string) {
    localStorage.setItem(this.userNameKey, userName);
  }

  get legalEntity(): LegalEntity {
    if (!localStorage.getItem(this.legalEntityKey)) {
      return LegalEntity.ToyotaGermany;
    }
    return LegalEntity.fromCountryBrand(localStorage.getItem(this.legalEntityKey) as CountryBrand)
  }

  setLegalEntity(legalEntity: LegalEntity) {
    localStorage.setItem(this.legalEntityKey, legalEntity.countryBrand);
  }

  get consentVersion(): string {
    return localStorage.getItem(this.consentVersionKey);
  }

  setConsentVersion(consentVersion: string) {
    localStorage.setItem(this.consentVersionKey, consentVersion);
  }
}
